import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'utils/base-query';

// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: 'authApi',
  tagTypes: ['Auth'],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getMe: builder.query({
      query: () => {
        return {
          url: '/admin/me'
        };
      }
    }),
    login: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: '/admin/login',
          body: data
        };
      }
    }),
    getUserToken: builder.query({
      query: (data) => {
        return {
          method: 'POST',
          url: '/admin/token',
          body: data
        };
      }
    }),
    getUserAuthToken: builder.query({
      query: (data) => {
        return {
          method: 'POST',
          url: '/admin/token',
          body: data
        };
      }
    }),
    updatePlanUsage: builder.mutation({
      query: ({ id, data }) => {
        return {
          method: 'PUT',
          url: `/admin/update-usage/${id}`,
          body: data
        };
      }
    }),
    getPlanUsage: builder.mutation({
      query: (id) => {
        return {
          method: 'GET',
          url: `/admin/user-usage/${id}`
        };
      }
    }),
    updateAdminAccount: builder.mutation({
      query: (data) => {
        return {
          method: 'PUT',
          url: `/admin/me`,
          body: data
        };
      }
    }),
    updateAdminAccountPassword: builder.mutation({
      query: (data) => {
        return {
          method: 'PUT',
          url: `/admin/me/password`,
          body: data
        };
      }
    }),
    cancelSubScription: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: `/admin/cancel-subscription`,
          body: data
        };
      }
    }),
    disableUser: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: '/admin/disable-user',
          body: data
        };
      }
    }),
    enableUser: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: '/admin/enable-user',
          body: data
        };
      }
    }),
    disableEnterprise: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: '/admin/disable-enterprise',
          body: data
        };
      }
    }),
    enableEnterprise: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: '/admin/enable-enterprise',
          body: data
        };
      }
    }),
    addCoupons: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: '/admin/add-coupons',
          body: data
        };
      }
    }),

    getUserPlans: builder.mutation({
      query: (queryParams) => {
        return {
          method: 'GET',
          url: '/admin/getUserPlans',
          params: queryParams
        };
      }
    }),
    getExportUserPlans: builder.mutation({
      query: () => {
        return {
          method: 'GET',
          url: '/admin/getExportUserPlans'
        };
      }
    }),

    getUserInvoices: builder.mutation({
      query: (params) => {
        return {
          method: 'GET',
          url: `/admin/getUserSubscriptions`,
          params
        };
      }
    }),
    getFilterUserPlans: builder.mutation({
      query: (params) => {
        return {
          method: 'GET',
          url: `/admin/getFilterUserPlans`,
          params
        };
      }
    }),
    getRevenueAnalytics: builder.mutation({
      query: (params) => {
        return {
          method: 'GET',
          url: `/admin/getRevenueAnalytics`,
          params
        };
      }
    }),
    getSignupUser: builder.mutation({
      query: (params) => {
        return {
          method: 'GET',
          url: `/admin/getSignupUser`,
          params
        };
      }
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLoginMutation,
  useGetPlanUsageMutation,
  useUpdatePlanUsageMutation,
  useGetUserTokenQuery,
  useGetMeQuery,
  useLazyGetUserAuthTokenQuery,
  useUpdateAdminAccountMutation,
  useUpdateAdminAccountPasswordMutation,
  useCancelSubScriptionMutation,
  useDisableUserMutation,
  useEnableUserMutation,
  useAddCouponsMutation,
  useGetUserPlansMutation,
  useGetExportUserPlansMutation,
  useGetUserInvoicesMutation,
  useGetFilterUserPlansMutation,
  useGetRevenueAnalyticsMutation,
  useGetSignupUserMutation,
  useDisableEnterpriseMutation,
  useEnableEnterpriseMutation
} = authApi;
